import { Permissions } from 'types';
import { User } from 'types/api/users.type';
import { PermissionsRow } from './EditForm/types';

const useDataForm = (
  isCatalogueValid: boolean,
  isAdmin: boolean,
  user?: User
): PermissionsRow[] => [
  {
    row: 1,
    colItems: [
      [
        {
          name: 'ADMIN',
          label: 'Admin',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.ADMIN),
        },
      ],
      [
        {
          name: 'NOTIFICATIONS',
          label: 'Notifications',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.NOTIFICATIONS),
          disabled: !isAdmin,
        },
        {
          name: 'USERS',
          label: 'Users',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.USERS),
          disabled: !isAdmin,
        },
      ],
    ],
  },
  {
    row: 2,
    colItems: [
      [
        {
          name: 'CATALOGUE',
          label: 'Catalogue',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.CATALOGUE),
        },
      ],
      [
        {
          name: 'VIEW_PRICE',
          label: 'Price',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.VIEW_PRICE),
          disabled: !isCatalogueValid,
        },
        {
          name: 'INSERT_BUDGET',
          label: 'Budget',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.INSERT_BUDGET),
          disabled: !isCatalogueValid,
        },
        {
          name: 'DISTRIBUTOR',
          label: 'Distributor',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.DISTRIBUTOR),
          disabled: !isCatalogueValid,
        },
      ],
      // A column of its own so the checkbox sits on the same line as "Price",
      // directly to its right. Independent of "Distributor": it only decides
      // whether the user sees the Distributor Price.
      [
        {
          name: 'VIEW_DISTRIBUTOR_PRICE',
          label: 'View Distributor Price',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.VIEW_DISTRIBUTOR_PRICE),
          disabled: !isCatalogueValid,
        },
      ],
      [
        {
          name: 'INSERT_ORDER',
          label: 'Orders',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.INSERT_ORDER),
          disabled: !isCatalogueValid,
        },
        {
          name: 'VIEW_ORDER',
          label: 'Reading orders',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.VIEW_ORDER),
          disabled: !isCatalogueValid,
        },
        {
          name: 'VIEW_INACTIVE_ITEMS',
          label: 'Inactive products',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.VIEW_INACTIVE_ITEMS),
          disabled: !isCatalogueValid,
        },
      ],
    ],
  },
  {
    row: 3,
    divider: true,
    colItems: [
      [
        {
          name: 'CUSTOMER_MAPPER',
          label: 'Customers',
          type: 'checkbox',
          isCheckIcon: true,
          defaultChecked: user?.permissions?.includes(Permissions.CUSTOMER_MAPPER),
          // ADMIN already has full Customer Mapper access via the admin
          // panel (no need for the literal group — see customer.controller.ts's
          // @AnyRole('ADMIN','CUSTOMER_MAPPER')) and is excluded from Customer
          // Mapper in the distributor-facing catalogue app regardless of this
          // flag (routePermissions.ts's excludePermissions). Disabled here
          // purely so the checkbox doesn't look like it does something for an
          // admin — it's cosmetic only, doesn't touch stored permissions.
          disabled: isAdmin,
        },
      ],
    ],
  },
];

export { useDataForm };
